import { render, staticRenderFns } from "./editrescuecenter.vue?vue&type=template&id=2b362e32&"
import script from "./editrescuecenter.vue?vue&type=script&lang=js&"
export * from "./editrescuecenter.vue?vue&type=script&lang=js&"
import style0 from "./editrescuecenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports